"use client";

import { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import LoadingScreen from '@/components/loading-screen';

interface ClientLayoutProps {
  children: React.ReactNode;
  loading?: boolean;
}

const ClientLayout = ({ children, loading }: ClientLayoutProps) => {
  const [internalLoading, setInternalLoading] = useState(true);

  useEffect(() => {
    if (typeof loading === 'boolean') {
      // If loading prop is provided, don't use timer
      setInternalLoading(loading);
      return;
    }
    // Fallback: Simulate loading time and ensure minimum display duration
    const timer = setTimeout(() => {
      setInternalLoading(false);
    }, 4000); // 4 seconds loading time

    return () => clearTimeout(timer);
  }, [loading]);

  const showLoading = typeof loading === 'boolean' ? loading : internalLoading;

  return (
    <>
      <AnimatePresence mode="wait">
        {showLoading && <LoadingScreen key="loading" />}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {!showLoading && (
          <div key="content">
            {children}
          </div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ClientLayout;